import { TransferPurchaseInfo } from './transferPurchaseInfo.model'
export interface ClearwaterTransaction {
  transactionId?: string
  legacyTranId?: number
  legacyOrigTranId?: number
  active: boolean
  tranType: string
  createdDate: string
  userId: number
  sourceId: number
  accountId: number
  entryDate: string
  settleDate: string
  traderId?: number
  tpiDataMap?: { [key: number]: TransferPurchaseInfo }
}

export const cwTransactionFieldMap = new Map<string, string>([
  ['accountId', 'Account ID'],
  ['accountFeeType', 'Account Fee Type'],
  ['amortTargetDate', 'Amort Target Date'],
  ['active', 'Active'],
  ['amortTargetPrice', 'Amort Target Price'],
  ['amount', 'Amount'],
  ['amortOverrideType', 'Amort Override Type'],
  ['actualPostDate"', 'Actual Post Date'],
  ['accrued', 'Accrued'],
  ['accruedAmount', 'Accrued Amount'],
  ['accruedInterest', 'Accrued Interest'],

  ['clearedDate', 'Cleared Date'],
  ['commission', 'Commission'],
  ['counterPartyId', 'Counterparty ID'],
  ['createdDate', 'Created Date'],
  ['cashSecurityId', 'Cash Security ID'],
  ['counterParty', 'Counter Party'],
  ['counterPartyName', 'Counter Party Name'],
  ['curUnits', 'Cur Units'],
  ['cusip', 'Cusip'],

  ['dataMap', 'Data Map'],
  ['destAccountId', 'Dest Account Id'],
  ['destPostDate', 'Dest Post Date'],
  ['destExpectedPostDate', 'Dest Expected Post Date'],
  ['destActualPostDate', 'Dest Actual Post Date'],
  ['discount', 'Discount'],
  ['destclearedDate', 'Dest Cleared Date'],

  ['exchangeType', 'Exchange Type'],
  ['entryDate', 'Entry Date'],
  ['expectedPostDate', 'Expected Post Date'],

  ['fromSecurityId', 'From Security ID'],
  ['fromSecurity', 'From Security'],
  ['fromUnits', 'From Units'],
  ['factor', 'Factor'],

  ['intraDayOrder', 'Intra-Day Order'],
  ['inventoryType', 'Inventory Type'],
  ['transactionId', 'Transaction ID'],

  ['modifiedDate', 'Modified Date'],

  ['originalId', 'Orig Transaction ID'],
  ['originationFee', 'Loan Origination Fee'],
  ['prepaidInterest', 'Loan Prepaid Interest'],
  ['interestDue', 'Loan Past Due Interest'],
  ['units', 'Orig Units'],

  ['postDate', 'Post Date'],
  ['price', 'Price'],

  ['revisionId', 'Revision ID'],
  ['recallableDistribution', 'Recallable Distribution'],

  ['sourceId', 'Source ID'],
  ['sourceName', 'Source Name'],
  ['settleDate', 'Settle Date'],
  ['sourceAccountId', 'Source Account Id'],
  ['securityId', 'Security ID'],
  ['security', 'Security'],
  ['sourcePostDate', 'Source Post Date'],
  ['sourceclearedDate', 'Source Cleared Date'],

  ['transferPrice', 'Transfer Price'],
  ['transactionType', 'Type'],
  ['toSecurityId', 'To Security ID'],
  ['toSecurity', 'To Security'],
  ['tpiDataMap', 'Transfer Purchase Info'],
  ['typeLabelId', 'Type Label Id'],
  ['typeLabel', 'Type Label'],
  ['toUnits', 'To Units'],
  ['traderId', 'Trader Id'],

  ['userId', 'User ID'],
  ['uuid', 'Transaction UUID'],
  ['unitRatio', 'Unit Ratio'],
  ['userName', 'User Name'],

  ['valuationDate', 'Valuation Date'],
  ['yield', 'Yield'],
  ['isCapitalize', 'Capitalized'],
])
